import { Client, Protocol } from '@tencent/mega-ipc-renderer';
class MegaFont {
    static queryLocalFonts() {
        return this.client.font.queryLocalFonts();
    }
}
MegaFont.client = Client.create({
    font: Protocol(),
});
export default MegaFont;
//# sourceMappingURL=mega-font.js.map